import React, { useState, useEffect, useCallback, useContext } from 'react';
import client from '@/lib/feathers';
import FunctionButtonGroup from './FunctionButtonGroup';
import DynamicTable from './DynamicTable';
import { BackStageContext } from '@/contexts/BackStageContext';

export default function Template({ dynamicStructure, setSelectedVendor }) {
  const [isUpdate, setIsUpdate] = useState(true);
  const [data, setData] = useState([]);

  const { backStageUpdateTrigger } = useContext(BackStageContext);

  const fetchData = useCallback(async (dbName) => {
    try {
      const res = (await client.service(dbName).find()).data;
      setData(res);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    if (dynamicStructure) {
      fetchData(dynamicStructure.dbName);
    }
    setIsUpdate(false);
  }, [isUpdate, dynamicStructure, fetchData, backStageUpdateTrigger]);

  return (
    <>
      {dynamicStructure && (
        <>
          {/* funcs */}
          <FunctionButtonGroup
            {...{ dynamicStructure, setIsUpdate, setSelectedVendor }}
          />
          {/* table */}
          <DynamicTable
            {...{ dynamicStructure, data, setIsUpdate, setSelectedVendor }}
          />
        </>
      )}
    </>
  );
}
